/**
 * (c) 2015 Ignite Sales, Inc.
 * User: aholmes
 * Date: 4/13/2016
 * Time: 11:37 AM
 */
import '../common';
import React from 'react';
import ReactDom from 'react-dom';
import Container from './components/Container';
import Fluxible from 'fluxible';
import {FluxibleComponent} from 'fluxible-addons-react';
import LoginStore from './stores/LoginStore';
import ContactMeStore from '../contactMe/stores/ContactMeStore';
import MessageStore from '../common/stores/MessageStore';
import MessageDefinitions from './i18n/MessageDefinitions';
import Messages from '../common/i18n/Messages';
import batchedUpdatePlugin from 'fluxible-addons-react/batchedUpdatePlugin';
import CommonActions from '../common/constants/CommonActions';
import Actions from './constants/Actions';
import {editEmployee, loadEmployeeById} from './actions/SearchActionCreators';

const app = new Fluxible({ component: Container });
app.plug(batchedUpdatePlugin());
app.registerStore(LoginStore);
app.registerStore(MessageStore);

function render(nodeId, {selectedEmployeeId, thirdPartyId, defaultFields} = {}) {
  const mountNode = document.getElementById(nodeId);
  app.rehydrate({}, (err, context) => {
    function doRender() {
      ReactDom.render(
        React.createElement(
          FluxibleComponent,
          {
            context: context.getComponentContext()
          },
          <Container/>
        ),
        mountNode
      );
    }
    context.executeAction(loadEmployeeById, {selectedEmployeeId, thirdPartyId}).then(employee => {
      context.getActionContext().dispatch(CommonActions.MESSAGES_LOADED, Messages.get(MessageDefinitions));
      if (employee && Object.keys(employee).length > 0) {
        context.getActionContext().dispatch(Actions.ENABLE_EDIT, false);
        doRender();
      } else if (defaultFields) {
        context.executeAction(editEmployee, {...defaultFields}).then(() => {
          doRender();
        });
      } else {
        doRender();
      }
    });
  });
}

function renderEmployeeDialog (employeeLoginId,params) {
  render(employeeLoginId, params || {});
}

if (window.ignite) {
  window.ignite.renderEmployeeDialog = renderEmployeeDialog;
}

export {
  renderEmployeeDialog
};



/** WEBPACK FOOTER **
 ** ./src/main/js/employeeLogin/index.js
 **/